import angular from "angular";
import ui_router from "angular-ui-router";
import ui_select from "ui-select";
import sanitize from "angular-sanitize";
import ng_tags_input from "ng-tags-input";

//End user hmrx application interface - @AppBundle
import app from "./app";
//Admin user hmrx interface - @AdminBundle
import admin from "./admin";

import routing from "./base.config";

// Nasty override because ngTagsInput doesn't export itself
let ngTagsInput = ng_tags_input? "ngTagsInput": null;

angular.module("hmrx", [
  ui_router,
  ui_select,
  sanitize,
  ngTagsInput,
  app,
  admin,
])
  .config(routing);



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/base.js
 **/